<fin-ancillaries
  [cartData$]="cartData$"
  [cartStatus$]="cartStatus$"
  [serviceAvailability$]="serviceAvailability$"
  [servicesReady$]="servicesReady$"
  (ready)="confirmAncillaries()"
  (message)="onMessage($event)"
></fin-ancillaries>
